import React from 'react'

interface DownloadIconProps {
    className?: string
    color?: string
}

const DownloadIcon: React.FC<DownloadIconProps> = ({ className, color = '#147BC2' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="11"
        height="13"
        viewBox="0 0 11 13"
        fill="none"
        className={className}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.14645 5.67157L5.32843 8.85355C5.52369 9.04882 5.84027 9.04882 6.03553 8.85355L9.21751 5.67157C9.41278 5.47631 9.41278 5.15973 9.21751 4.96447C9.02225 4.7692 8.70567 4.7692 8.51041 4.96447L6.18198 7.29289V0.5C6.18198 0.223858 5.95812 -3.29297e-09 5.68198 0C5.40584 3.29297e-09 5.18198 0.223858 5.18198 0.5V7.29289L2.85355 4.96447C2.65829 4.7692 2.34171 4.7692 2.14645 4.96447C1.95118 5.15973 1.95118 5.47631 2.14645 5.67157Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 9C1.27614 9 1.5 9.22386 1.5 9.5V11.5H9.5V9.5C9.5 9.22386 9.72386 9 10 9C10.2761 9 10.5 9.22386 10.5 9.5V12.5H0.5V9.5C0.5 9.22386 0.723858 9 1 9Z"
            fill={color}
        />
    </svg>
)

export default DownloadIcon
